import { Link, NavLink, useNavigate } from "react-router-dom";
import { Radio, Trophy, User, CalendarDays, LogOut, LogIn, Shield, Signal, History } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const linkCls = ({ isActive }) =>
  `px-3 py-2 rounded-lg text-sm font-semibold uppercase tracking-wider transition-colors flex items-center gap-2 ${
    isActive ? "text-amber-400 bg-white/5" : "text-slate-300 hover:text-white hover:bg-white/5"
  }`;

export default function Navbar() {
  const { user, logout, setAuthOpen } = useAuth();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 border-b border-white/10 bg-[#070A10]/85 backdrop-blur-xl">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2.5" data-testid="brand-home-link">
          <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-amber-500 to-orange-600 flex items-center justify-center shadow-lg shadow-amber-500/30">
            <Radio className="w-5 h-5 text-[#0B0F17]" strokeWidth={2.5} />
          </div>
          <div className="leading-none">
            <div className="font-display font-black text-lg tracking-tight uppercase text-white">The Cricket Pitch Oracle</div>
            <div className="font-mono-data text-[10px] uppercase tracking-[0.24em] text-amber-400/80">Over • by • Over</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/" end className={linkCls} data-testid="nav-live-matches-link"><Radio className="w-4 h-4" />Arena</NavLink>
          <NavLink to="/live" className={linkCls} data-testid="nav-live-feed-link"><Signal className="w-4 h-4" />Live Feed</NavLink>
          <NavLink to="/schedule" className={linkCls} data-testid="nav-schedule-link"><CalendarDays className="w-4 h-4" />Schedule</NavLink>
          <NavLink to="/leaderboard" className={linkCls} data-testid="nav-leaderboard-link"><Trophy className="w-4 h-4" />Leaderboard</NavLink>
          {user && <NavLink to="/profile" className={linkCls} data-testid="nav-profile-link"><User className="w-4 h-4" />Profile</NavLink>}
          {user && <NavLink to="/history" className={linkCls} data-testid="nav-history-link"><History className="w-4 h-4" />History</NavLink>}
          {user?.is_admin && <NavLink to="/admin/players" className={linkCls} data-testid="nav-admin-link"><Shield className="w-4 h-4" />Admin</NavLink>}
        </nav>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              <div className="hidden sm:flex flex-col items-end leading-tight">
                <span className="text-xs text-slate-400 uppercase tracking-wider">{user.name}</span>
                <span className="font-mono-data text-amber-400 font-bold text-sm" data-testid="nav-user-points">{user.points ?? 0} pts</span>
              </div>
              <button onClick={() => { logout(); nav("/"); }} className="btn-ghost text-xs" data-testid="nav-logout-button">
                <LogOut className="w-4 h-4 inline mr-1.5" />Sign out
              </button>
            </>
          ) : (
            <button onClick={() => setAuthOpen(true)} className="btn-primary text-xs" data-testid="nav-auth-button">
              <LogIn className="w-4 h-4 inline mr-1.5" />Sign in
            </button>
          )}
        </div>
      </div>
    </header>
  );
}
